import { render } from "./simpleEditor.vue?vue&type=template&id=ea4f2e3c&scoped=true"
import script from "./simpleEditor.vue?vue&type=script&lang=js"
export * from "./simpleEditor.vue?vue&type=script&lang=js"

import "./simpleEditor.vue?vue&type=style&index=0&id=ea4f2e3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea4f2e3c"]])

export default __exports__